export default __webpack_public_path__ + "static/media/closeBtn.2286b8f8.webp";